import React, { Component } from 'react'
import { debounce } from 'lodash'

class ToDoItem extends Component {

    constructor(props) {
        super(props)
        this.state = {
            item: props.item
        }
    }

    componentWillMount() {
        this.autoSaveOnChange = debounce(e => {
            console.log("Debounce ", e.target.value)
            this.props.onUpdate(this.state.item)
        }, 1500)
    }

    handleDoneChange(e) {
        var item = this.state.item
        item.done = !item.done
        this.setState({ item: item })
        this.props.onUpdate(item)
    }

    handleTaskChange(e) {
        var item = this.state.item
        item.task = e.target.value
        this.setState({ item: item })
        console.log("Title updated ", item)
        // Try to sasve it after debounce time has been elapsed
        e.persist()
        this.autoSaveOnChange(e)
    }

    handleDelete() {
        this.autoSaveOnChange.cancel() // cancel auto save if there is a pending one
        this.props.onDelete(this.state.item)
    }

    render() {
        return (
            <div className="input-group mb-3">
                <div className="input-group-prepend">
                    <div className="input-group-text">
                        <input type="checkbox" aria-label="task state" checked={this.state.item.done} onChange={(e) => this.handleDoneChange(e)} />
                    </div>
                </div>
                <input className="form-control" type="text" value={this.state.item.task} style={{ textDecoration: this.state.item.done ? 'line-through' : '' }} onChange={(e) => this.handleTaskChange(e)} />
                <div className="input-group-append">
                    <button className="btn btn-outline-danger" type="button" onClick={() => this.handleDelete()}>Delete</button>
                </div>
            </div >
        )
    }
}

export default class ToDoList extends Component {
    render() {
        return (
            <div>
                {this.props.items.map(item => <ToDoItem item={item} key={item.task + item.done} onUpdate={this.props.onItemUpdated} onDelete={this.props.onItemDelete} />)}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/ToDoList.jsx